import { createSlice } from "@reduxjs/toolkit";
// import { getLocalStorageItem } from "../Utils";

const initialState = {
  heading: "Dashboard",
  subHeading: "",
  selectedTab: "",
  // RECHARGE STATES
  profileDetail: {},
  walletBal: "",
  aepswalletBal: "",
  commissionwalletBal: "",
  memberServices: [],
  walletType: [],
  personalDetail: {},
  merchantDetail: {},
  bankDetail: {},
  documents: {},
};

export const b2bSlice = createSlice({
  name: "B2B",
  initialState,
  reducers: {
    setHeadings: (state, action) => {
      state.heading = action.payload;
    },
    setselectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setSubHeadings: (state, action) => {
      state.subHeading = action.payload;
    },
    setProfile: (state, action) => {
      state.profileDetail = action.payload;
    },
    setWalletBal: (state, action) => {
      state.walletBal = action.payload;
    },
    setAEPSWalletBal: (state, action) => {
      state.aepswalletBal = action.payload;
    },
    setCommissionWalletBal: (state, action) => {
      state.commissionwalletBal = action.payload;
    },
    setMemberService: (state, action) => {
      const map = action.payload?.map((i) => i.service_id);
      state.memberServices = map;
    },
    setWalletType: (state, action) => {
      const map = action.payload?.map((i) => i);
      state.walletType = map;
    },
    setPersonalDetail: (state, action) => {
      state.personalDetail = action.payload;
    },
    setMerchantDetail: (state, action) => {
      state.merchantDetail = action.payload;
    },
    setBankDetail: (state, action) => {
      state.bankDetail = action.payload;
    },
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    clearOnboardDetail: (state) => {
      state.personalDetail = {};
      state.merchantDetail = {};
      state.bankDetail = {};
      state.documents = {};
    },
    clearAllRedux: (state) => {
      state.personalDetail = {};
      state.merchantDetail = {};
      state.bankDetail = {};
      state.documents = {};
      state.heading = "Dashboard";
      state.subHeading = "";
      state.selectedTab = "";
      state.profileDetail = {};
      state.walletBal = "";
      (state.aepswalletBal = ""),
        (state.commissionwalletBal = ""),
        (state.memberServices = []);
      state.walletType = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setHeadings,
  setProfile,
  setselectedTab,
  setWalletBal,
  setAEPSWalletBal,
  setCommissionWalletBal,
  setSubHeadings,
  setMemberService,
  setWalletType,
  setPersonalDetail,
  setMerchantDetail,
  setBankDetail,
  clearOnboardDetail,
  setDocuments,
  clearAllRedux,
} = b2bSlice.actions;

export default b2bSlice.reducer;
